import {
  Body1Strong,
  Button,
  MessageBar,
  MessageBarActions,
  MessageBarBody,
} from '@fluentui/react-components';
import { DismissRegular, ErrorCircleFilled } from '@fluentui/react-icons';
import React, { useEffect, useState } from 'react';

export interface ApiPermissionBannerProps {
  message: string;
  sessionStorageKey: string;
  testIdPrefix: string;
  onGrantAccess: () => void;
  onDismissedChange?: (dismissed: boolean) => void;
}

export const ApiPermissionBanner: React.FC<ApiPermissionBannerProps> = ({
  message,
  sessionStorageKey,
  testIdPrefix,
  onGrantAccess,
  onDismissedChange,
}) => {
  const [dismissed, setDismissed] = useState(() => {
    return sessionStorage.getItem(sessionStorageKey) === 'true';
  });

  useEffect(() => {
    if (sessionStorage.getItem('msal_first_time_login') === 'true') {
      sessionStorage.removeItem(sessionStorageKey);
      setDismissed(false);
      onDismissedChange?.(false);
    }
  }, [sessionStorageKey, onDismissedChange]);

  const handleDismiss = () => {
    setDismissed(true);
    sessionStorage.setItem(sessionStorageKey, 'true');
    onDismissedChange?.(true);
  };

  if (dismissed) {
    return null;
  }

  return (
    <MessageBar icon={<ErrorCircleFilled />} intent="error" data-testid={`${testIdPrefix}-api-permission-warning-messagebar`}>
      <MessageBarBody>
        <span style={{ color: '#8A001E' }}>
          <Body1Strong>{message}</Body1Strong> Grant consent to enable the required permissions.
        </span>
      </MessageBarBody>
      <MessageBarActions
        containerAction={
          <Button
            onClick={handleDismiss}
            appearance="transparent"
            size="small"
            icon={<DismissRegular />}
            aria-label="Dismiss"
            data-testid={`${testIdPrefix}-dismiss-api-permission-banner-button`}
          />
        }
      >
        <Button
          appearance="primary"
          style={{ fontWeight: 400, fontSize: '14px', borderRadius: "4px", padding: "4px 12px", gap: '4px' }}
          onClick={onGrantAccess}
          data-testid={`${testIdPrefix}-grant-access-button`}
        >
          Grant consent
        </Button>
      </MessageBarActions>
    </MessageBar>
  );
};
